module.exports = __webpack_public_path__ + "static/logo--blue-planet-light.8af65443.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo--blue-planet-light.png
// module id = 1309
// module chunks = 168707334958949